import * as S from './style';
import CircleFill from '@svgIcons/circle-fill.svg';

export const TimePicker = {
    name: 'TimePicker',
    props: {
        hour: {
            type: Number,
            default: 0,
        },
        minute: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            localHour: String(this.hour),
            localMinute: String(this.minute),
        };
    },
    computed: {
        isFormValid() {
            if (this.localHour === '' || this.localMinute === '') {
                return false;
            }

            return this.isHourValid && this.isMinuteValid;
        },
        isHourValid() {
            if (this.localHour === '') return true;
            const hour = Number(this.localHour);
            return hour >= 0 && hour <= 23;
        },
        isMinuteValid() {
            if (this.localMinute === '') return true;
            const minute = Number(this.localMinute);
            return minute >= 0 && minute <= 59;
        },
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
        this.$nextTick(() => {
            const hourInput = this.$el.querySelector('.time-picker-hour-input');
            if (hourInput) {
                hourInput.focus();
            }
        });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
    methods: {
        handleKeyDown(event) {
            if (event.key === 'Enter' && this.isFormValid) {
                this.handleSave();
            } else if (event.key === 'Escape') {
                this.handleClose();
            }
        },
        checkIsValidNumberInput(value) {
            if (!/^\d*$/.test(value)) return false;
            const numValue = Number(value);
            return !isNaN(numValue);
        },
        checkIsValidTimeInput({ value, maxLength = 2 }) {
            if (
                !this.checkIsValidNumberInput(value) ||
                value.length > maxLength
            ) {
                return false;
            }
            return true;
        },
        handleHourInput(event) {
            let value = event.target.value;

            if (value === '') {
                this.localHour = '';
                return;
            }

            if (!this.checkIsValidTimeInput({ value })) {
                event.target.value = this.localHour;
                return;
            }

            this.localHour = value;
        },
        handleMinuteInput(event) {
            let value = event.target.value;

            if (value === '') {
                this.localMinute = '';
                return;
            }

            if (!this.checkIsValidTimeInput({ value })) {
                event.target.value = this.localMinute;
                return;
            }

            this.localMinute = value;
        },
        handleSave() {
            this.$emit('change', {
                hour: parseInt(this.localHour),
                minute: parseInt(this.localMinute),
            });
        },
        handleClose() {
            this.$emit('close');
        },
    },
    render() {
        return (
            <S.TimePickerWrapper class="time-picker">
                <S.TimePickerHeader>
                    <S.TimePickerTitle>
                        {this.$t('EXPORT_DATA.time_picker_title')}
                    </S.TimePickerTitle>
                </S.TimePickerHeader>
                <S.TimeInputWrapper>
                    <S.TimePickerColumn>
                        <S.TimePickerInputLabel>Hour</S.TimePickerInputLabel>
                        <S.TimePickerInputWrapper isError={!this.isHourValid}>
                            <input
                                type="text"
                                value={this.localHour}
                                onInput={this.handleHourInput}
                                placeholder="00"
                                class="time-picker-hour-input"
                            />
                        </S.TimePickerInputWrapper>
                    </S.TimePickerColumn>
                    <S.TimeSeparatorWrapper>
                        <CircleFill
                            width="6"
                            height="6"
                            fill="var(--color-gray-80)"
                        />
                        <CircleFill
                            width="6"
                            height="6"
                            fill="var(--color-gray-80)"
                        />
                    </S.TimeSeparatorWrapper>
                    <S.TimePickerColumn>
                        <S.TimePickerInputLabel>Minute</S.TimePickerInputLabel>
                        <S.TimePickerInputWrapper isError={!this.isMinuteValid}>
                            <input
                                type="text"
                                value={this.localMinute}
                                onInput={this.handleMinuteInput}
                                placeholder="00"
                                class="time-picker-minute-input"
                            />
                        </S.TimePickerInputWrapper>
                    </S.TimePickerColumn>
                </S.TimeInputWrapper>
                <S.TimePickerFooter>
                    <S.Button onClick={this.handleClose}>
                        {this.$t('COMMON.cancel')}
                    </S.Button>
                    <S.Button
                        primary
                        onClick={this.handleSave}
                        disabled={!this.isFormValid}
                    >
                        {this.$t('COMMON.create')}
                    </S.Button>
                </S.TimePickerFooter>
            </S.TimePickerWrapper>
        );
    },
};

export default TimePicker;
